import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function israeliIdValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		let value = control.value;

		if (!value) {
			return null; // Let required validator handle empty values
		}

		// Convert to string and trim whitespace
		const strVal = String(value).trim();

		// Must be numeric and up to 9 digits long
		if (!/^\d+$/.test(strVal) || strVal.length > 9 || strVal.length < 5) {
			return { israeliIdInvalid: true };
		}

		// Pad with leading zeros to make it 9 digits
		const padded = strVal.padStart(9, '0');

		// Luhn / Israeli ID checksum algorithm
		let sum = 0;
		for (let i = 0; i < 9; i++) {
			let digit = parseInt(padded.charAt(i), 10);
			let step = digit * ((i % 2) + 1);
			if (step > 9) {
				step -= 9;
			}
			sum += step;
		}

		const isValid = sum % 10 === 0;
		return isValid ? null : { israeliIdInvalid: true };
	};
}
